import { createContext } from "react";

const MainViewContext = createContext();

export default MainViewContext;
